"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveButton = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const Icon_1 = require("../../Icon");
require("./index.scss");
const className = 'remove-button';
class RemoveButton extends react_1.default.PureComponent {
    renderIconOnRight(iconBlock, textBlock) {
        return react_1.default.createElement(react_1.default.Fragment, null,
            textBlock,
            iconBlock);
    }
    renderIconOnLeft(iconBlock, textBlock) {
        return react_1.default.createElement(react_1.default.Fragment, null,
            iconBlock,
            textBlock);
    }
    render() {
        const { text, right, hidden, modificators } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        const spanClassModifier = right ? 'icon-right' : 'icon';
        const iconBlock = (react_1.default.createElement("span", { className: `${className}__${spanClassModifier}` },
            react_1.default.createElement(Icon_1.Icon, { name: 'x' })));
        const textBlock = text && (react_1.default.createElement("span", { className: `${className}__text` }, text)) || null;
        if (hidden)
            return null;
        return (react_1.default.createElement("button", { onClick: this.props.onClick, className: classNames }, right
            ? this.renderIconOnRight(iconBlock, textBlock)
            : this.renderIconOnLeft(iconBlock, textBlock)));
    }
}
exports.RemoveButton = RemoveButton;
RemoveButton.defaultProps = {
    right: false,
    text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Button:Remove', defaultMessage: 'Remove' })),
    onClick: () => {
    },
};
//# sourceMappingURL=index.js.map